export default "__VITE_ASSET__rcTFfrvn__"